import api from './axiosService';

export const shopSellerApi = {
    getAll(params = {}) {
        return api.get('/shop-sellers', { params });
    },

    getMyShops(params = {}) {
        return api.get('/shop-sellers/my-shops', { params });
    },

    getAvailableSellers(params = {}) {
        return api.get('/shop-sellers/available', { params });
    },

    getById(shopSellerId) {
        return api.get(`/shop-sellers/${shopSellerId}`);
    },

    getByShop(shopId, params = {}) {
        return api.get(`/shop-sellers/shop/${shopId}`, { params });
    },

    getTotalByShop(shopId) {
        return api.get(`/shop-sellers/shop/${shopId}/total`);
    },

    create(data) {
        return api.post('/shop-sellers', data);
    },

    update(shopSellerId, data) {
        return api.put(`/shop-sellers/${shopSellerId}`, data);
    },

    setStatus(shopSellerId, status) {
        return api.patch(`/shop-sellers/${shopSellerId}/status`, { status });
    },

    toggleStatus(shopSellerId) {
        return api.patch(`/shop-sellers/${shopSellerId}/toggle-status`);
    },
};